import React, { useState, Fragment } from "react";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  StyledTypography,
  StyledTypographyDiv,
  StyledIconButton,
  StyledMainDiv,
  StyledAccordion,
  StyledTypographyText,
  DeleteIconWrapper,
} from "./NotifCard.style";
import { MdDelete, MdEdit } from "react-icons/md";

export default function NotifCard(props) {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Fragment>
      {props.rows.map((row, index) => {
        return (
          <StyledMainDiv key={"row" + row.id}>
            <StyledAccordion
              expanded={expanded === `"panel" + ${row.id}`}
              onChange={handleChange(`"panel" + ${row.id}`)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <StyledTypographyDiv>
                  <StyledTypography
                    sx={{ width: "15%", flexShrink: 0, color: " #1e1e1e" }}
                  >
                    {index + 1}
                  </StyledTypography>
                  <StyledTypography sx={{ width: "33%", flexShrink: 0 }}>
                    {row?.title}
                  </StyledTypography>
                </StyledTypographyDiv>
              </AccordionSummary>
              <AccordionDetails>
                <StyledTypographyText>{row.text}</StyledTypographyText>
              </AccordionDetails>
            </StyledAccordion>
            <DeleteIconWrapper>
              <StyledIconButton
                aria-label="ویرایش"
                onClick={() => console.log("edit : ", row.id)}
              >
                <MdEdit fill="#ffba24" size={24} />
              </StyledIconButton>
            </DeleteIconWrapper>
            <DeleteIconWrapper>
              <StyledIconButton
                aria-label="حذف"
                onClick={() => props.onDelete(row.id)}
              >
                <MdDelete fill="#ff2424" size={24} />
              </StyledIconButton>
            </DeleteIconWrapper>
          </StyledMainDiv>
        );
      })}
    </Fragment>
  );
}
